import { useEffect, useState } from 'react';
import { navLinks, siteMeta } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 md:h-[72px] items-center justify-between gap-4">
          {/* logo + H1 */}
          <a href="#top" className="flex items-center gap-2.5 shrink-0">
            <span className="flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg md:text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <h1 className="font-heading text-lg md:text-xl font-black tracking-wide text-foreground-950 whitespace-nowrap">
                五一<span className="text-primary-600">黑料</span>
              </h1>
              <span className="mt-1 hidden sm:block text-[11px] text-foreground-500 whitespace-nowrap">
                {siteMeta.updateTag}
              </span>
            </span>
          </a>

          {/* desktop nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600 whitespace-nowrap"
              >
                {n.label}
              </a>
            ))}
          </nav>

          {/* search + action */}
          <div className="flex items-center gap-2">
            <div className="hidden md:flex items-center gap-2 rounded-md border border-background-200 bg-background-50/70 px-3 py-2">
              <i className="ri-search-line text-foreground-400"></i>
              <input
                type="text"
                placeholder="搜索你想看的瓜"
                className="w-32 lg:w-44 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <a
              href="#packs"
              className="hidden sm:inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-download-2-line"></i>
              打包合集
            </a>
            <button
              onClick={() => setOpen((v) => !v)}
              aria-label="菜单"
              className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-100"
            >
              <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>
        </div>

        {/* mobile panel */}
        {open && (
          <div className="lg:hidden border-t border-background-200 py-3 pb-4">
            <div className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100/60 px-3 py-2.5 mb-3">
              <i className="ri-search-line text-foreground-400"></i>
              <input
                type="text"
                placeholder="搜索你想看的瓜"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <nav className="grid grid-cols-2 gap-1">
              {navLinks.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md bg-background-100/60 px-3 py-2.5 text-sm text-foreground-800 whitespace-nowrap"
                >
                  {n.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}